// Detecta el idioma del navegador
const detectLocale = () => {
    const userLocale = navigator.language || "es-ES" // Idioma del navegador (e.g., 'es-ES', 'en-GB')
    return userLocale
}

// Helper para formatear el importe como moneda
const formatCurrency = (amount, currency = "EUR") => {
    if (typeof amount !== 'number') return "N/A" // Controla si no es un número
    return new Intl.NumberFormat(detectLocale(), {
      style: 'currency',
      currency,
      useGrouping: true,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount)
  }
  
  export default formatCurrency
  